import React from 'react';
import classnames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons';
import { useNewControllableValue } from '../../utils/use-controllable-value';
var classPrefix = 'adm-desense-text';
var defaultProps = {
  defaultDesense: true
};
export var DesenseText = function DesenseText(p) {
  var props = mergeProps(defaultProps, p);
  var text = props.text,
      desenseText = props.desenseText;

  var _useNewControllableVa = useNewControllableValue({
    value: props.desense,
    defaultValue: props.defaultDesense,
    onChange: props.onChange
  }),
      isDesense = _useNewControllableVa[0],
      setIsDesense = _useNewControllableVa[1];

  return withNativeProps(props, /*#__PURE__*/React.createElement("span", {
    className: classPrefix
  }, isDesense ? desenseText : text, /*#__PURE__*/React.createElement("a", {
    className: classnames(classPrefix + "-icon-wrap", 'adm-plain-anchor'),
    onClick: function onClick() {
      setIsDesense(!isDesense);
    }
  }, isDesense ? /*#__PURE__*/React.createElement(EyeInvisibleOutline, null) : /*#__PURE__*/React.createElement(EyeOutline, null))));
};